import { render, staticRenderFns } from "./CommonHome.vue?vue&type=template&id=2c35a0a9&scoped=true&"
import script from "./CommonHome.vue?vue&type=script&lang=js&"
export * from "./CommonHome.vue?vue&type=script&lang=js&"
import style0 from "./CommonHome.vue?vue&type=style&index=0&id=2c35a0a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c35a0a9",
  null
  
)

export default component.exports